var _a;
import { UnitSuffix } from '../../defs';
import { noConvert } from '../../internal/converters';
import { pixel } from '../../internal/converters/pixel';
var emToPixel = function (value, options) {
    return value * options.emPixelValue();
};
var emToCentimeter = function (value, options) {
    return pixel.cm(emToPixel(value, options));
};
var emToMillimeter = function (value, options) {
    return pixel.mm(emToPixel(value, options));
};
var emToQuarter = function (value, options) {
    return pixel.Q(emToPixel(value, options));
};
var emToInch = function (value, options) {
    return pixel.in(emToPixel(value, options));
};
var emToPica = function (value, options) {
    return pixel.pc(emToPixel(value, options));
};
var emToPoint = function (value, options) {
    return pixel.pt(emToPixel(value, options));
};
var emToREM = function (value, options) {
    return pixel.rem(emToPixel(value, options), options);
};
var emToViewWidth = function (value, options) {
    return pixel.vw(emToPixel(value, options), options);
};
var emToViewHeight = function (value, options) {
    return pixel.vh(emToPixel(value, options), options);
};
var emToViewMin = function (value, options) {
    return pixel.vmin(emToPixel(value, options), options);
};
var emToViewMax = function (value, options) {
    return pixel.vmax(emToPixel(value, options), options);
};
export var em = (_a = {},
    _a[UnitSuffix.Pixel] = emToPixel,
    _a[UnitSuffix.Centimeter] = emToCentimeter,
    _a[UnitSuffix.Millimeter] = emToMillimeter,
    _a[UnitSuffix.Quarter] = emToQuarter,
    _a[UnitSuffix.Inch] = emToInch,
    _a[UnitSuffix.Pica] = emToPica,
    _a[UnitSuffix.Point] = emToPoint,
    _a[UnitSuffix.REM] = emToREM,
    _a[UnitSuffix.EM] = noConvert,
    _a[UnitSuffix.ViewWidth] = emToViewWidth,
    _a[UnitSuffix.ViewHeight] = emToViewHeight,
    _a[UnitSuffix.ViewMin] = emToViewMin,
    _a[UnitSuffix.ViewMax] = emToViewMax,
    _a);
//# sourceMappingURL=em.js.map